import { render } from "./specialSubjectAddView.vue?vue&type=template&id=0c5049d4&scoped=true&ts=true"
import script from "./specialSubjectAddView.vue?vue&type=script&lang=ts"
export * from "./specialSubjectAddView.vue?vue&type=script&lang=ts"

import "./specialSubjectAddView.vue?vue&type=style&index=0&id=0c5049d4&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5049d4"]])

export default __exports__